<template>
    <div id="mechanizationList">
        <div class="con">
            <img class="imgborder" src="../../assets/vehicleData/border.png" alt="">
            <div class="details">
                <div class="close" @click="close">
                    <img src="../../assets/vehicleData/close.png" alt="">
                </div>
                <div class="title">
                    <img src="../../assets/vehicleData/left.png" alt="">
                    <span class="text">机械化率</span>
                    <img src="../../assets/vehicleData/right.png" alt="">
                </div>
                <div class="line"><img src="../../assets/vehicleData/line.png" alt=""></div>
                <div class="content">
                    <div class="content-item">
                        <div class="content_left">
                            <div class="circular">
                                <div class="circular1">
                                    <img src="../../assets/vehicleData/circle-outer.png" alt="">
                                </div>
                                <div class="circular2">
                                    <img src="../../assets/vehicleData/circle-inner.png" alt="">
                                </div>
                                <div class="text">
                                    <div class="text_details">
                                        <div class="text1">{{rate}}%</div>
                                    </div>
                                </div>
                            </div>
                            <div class="content_left_text">机械化率</div>
                        </div>
                        <div class="content_right">
                            <div class="tab-change"  v-if="layer!=='县'&&layer!=='合作社'">
                                <div class="tab-change-item tab-change-item1" :class="{'tab-change-item-active':changeIndex==1}" @click="tabChange(1)">地区</div>
                                <div class="tab-change-item" :class="{'tab-change-item-active':changeIndex==2}" @click="tabChange(2)">农作物</div>
                            </div>
                            <div class="mechanizationBar" :class="{'barHeight':layer=='县'||layer=='合作社'}">
                                <zny-charts :chartData="chartData"/>
                            </div>
<!--                            <div id="mechanizationBar" class="mechanizationBar" :class="{'barHeight':layer=='县'||layer=='合作社'}"></div>-->
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import {Chart} from "../../js/echarts";
import WitVehicleStatisticsService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.WitVehicleStatisticsService.js';
import eventBus from "../../eventBus";
export default {
    data(){
        return{
            layer:localStorage.getItem('layer'),
            changeIndex:1,
            rate:0,
            cropData:[],//存储总数据
            dataList:[],//存储图表数据
            chartData:{//echarts图标数据
                show:false,
                option:{}
            }
        }
    },
    mounted(){
        var that = this
        that.onload()
    },
    methods:{
        onload(){
            var that = this
            that.getDataList()
            // console.log(that.layer)
            //年份改变时重新加载
            eventBus.$on('yearChange',function () {
                that.changeIndex=1
                that.getDataList()
            })
            //数据上报成功时重新加载
            eventBus.$on('reportDataSuccess',function () {
                that.changeIndex=1
                that.getDataList()
            })
        },
        //菜单切换
        tabChange(num){
            var that = this
            that.changeIndex=num
            if(num===1){
                that.dataList=that.cropData.regionListVos
                setTimeout(function () {
                    that.$nextTick(function () {
                        Chart.mechanizationBar(that,that.dataList)
                    })
                }, 500)
            }else if(num==2){
                that.dataList=that.cropData.dataReportingCropsVo
                setTimeout(function () {
                    that.$nextTick(function () {
                        Chart.mechanizationBar(that,that.dataList)
                    })
                }, 500)
            }
        },
        //获取列表
        getDataList(){
            var that = this
            WitVehicleStatisticsService.showMechanizationRateInformation(that.$store.state.time)
            .then(res=>{
                that.cropData=res
                that.rate=res.mechanizationRateOfYear
                if(that.layer=='县'||that.layer=='合作社'){
                    that.dataList=res.dataReportingCropsVo
                    setTimeout(function () {
                        that.$nextTick(function () {
                            Chart.mechanizationBar(that,that.dataList,1)
                        })
                    }, 500)
                }else{
                    that.dataList=res.regionListVos
                    setTimeout(function () {
                        that.$nextTick(function () {
                            Chart.mechanizationBar(that,that.dataList,2)
                        })
                    }, 500)
                }

            })
        },
        // 点击关闭
        close(){
            // this.$store.state.list=''
            this.$store.state.details=''
            this.$store.state.vehicleDataDialog=false
            this.$store.state.detailList=''
            this.$store.state.list='centerBot'
        },
    },
    beforeDestroy() {
        eventBus.$off('yearChange')
        eventBus.$off('reportDataSuccess')
    }
}
</script>
<style lang="less">
@import '../../viewsStyle/vehicleData/mechanizationList.less';

</style>